var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCheckBold = function SvgIconCheckBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.352 6.351 6.368 19.335l2.663 2.663L22.015 9.015z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.743 12.384 2.08 15.047l6.951 6.951 2.663-2.663z"
  })));
};
export default SvgIconCheckBold;